const RAW_BASE = (import.meta.env.VITE_API_URL ?? '').toString();
export const API_BASE = RAW_BASE.replace(/\/$/, '');
export const WS_BASE = API_BASE.replace(/^http(s?):\/\//, (_m, s) => `ws${s}://`);

export function apiUrl(path: string): string {
  return `${API_BASE}${path}`;
}

export function wsUrl(path: string): string {
  return `${WS_BASE}${path}`;
}

export function apiFetch(path: string, init?: RequestInit): Promise<Response> {
  return fetch(apiUrl(path), init);
}

/**
 * Same as `apiFetch` but attaches `Authorization: Bearer <token>`. Caller
 * passes the token explicitly so this stays decoupled from the player
 * store and can be used outside React. Pass `null` / empty to send no
 * header (server will 401 on gated routes).
 */
export function apiFetchWithToken(
  path: string,
  token: string | null | undefined,
  init?: RequestInit,
): Promise<Response> {
  const headers = new Headers(init?.headers);
  if (token) headers.set('Authorization', `Bearer ${token}`);
  return fetch(apiUrl(path), { ...init, headers });
}
